
const types = {

    HTTP_PENDING_KOBO_IMPORTER: 'HTTP_PENDING_KOBO_IMPORTER',
    HTTP_ERROR_KOBO_IMPORTER: 'HTTP_ERROR_KOBO_IMPORTER',
    HTTP_SUCCESS_KOBO_IMPORTER: 'HTTP_SUCCESS_KOBO_IMPORTER',

   
}
const actions = {
    //HTTP
    startHTTPRequest: () => ({
        type: types.HTTP_PENDING_KOBO_IMPORTER,
    }),
    stopHTTPRequestError: (error) => ({
        type: types.HTTP_ERROR_KOBO_IMPORTER,
        error: error
    }),
    stopRequestSuccess: (payload) => ({
        type: types.HTTP_SUCCESS_KOBO_IMPORTER,
        payload: payload
    }),

    
}



export { types, actions };
